/* Constants */
export const BASE_URL = 'https://sound-wave.b.goit.study/api';
export const API_ENDPOINTS = {
  ARTISTS: '/artists',
  ARTIST_BY_ID: '/artists/',
  ARTIST_ALBUMS_BY_ID: '/albums',

  GENRES: '/genres',

  FEEDBACKS: '/feedbacks',
  PRODUCTS_BY_CATEGORY: '/products/category/',
};
export const ARTISTS_PER_PAGE = 8;
export const FEEDBACKS_PER_QUEUE = 10;
